import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: JSON.stringify(data || {}),
  };

  return options;
};

export const createNewChannel = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel/create',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const viewChannelById = async (id) => {
  const options = prepareRequestOptions(`/admin/channel/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const updateChannelById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/update`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const deleteChanelById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/delete`,
    'DELETE'
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListChannels = async () => {
  const options = prepareRequestOptions('/admin/channels/search-list', 'GET');

  const response = await axios(options);
  return response.data;
};

export const uploadVideoToBunnyCDN = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/upload/video/cdn`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};
